import React, { Component } from "react";
import { Redirect, Link, history } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from "./../../Header";
import CustomerTabMenu from "./CustomerTabMenu";
import config from "react-global-configuration";
import $ from "jquery";
import {
	getCustomers,
	customer_details,
	getAllAccountManager,
	allmuvisixfunc,
	getMuvisixCustomerActn,
	muvisixCustomerSearchHandler,
	loadMoreAct,
	paginationHandel,
	goToCustomerStore,
	userDataEncryptMuvi6,
	assignMuvi6AccountManager,
	SaveAccountManager,
	removeAccountManager_muvi6,
	RemoveAccountManagerMuvi5,
	Savepassword,
	CancelAccountMuvi5,
	raiseInvoice,
	fetchProductByKey,
	getMuviClassicCount,
} from "../../actions/customerListAction";
import { connect } from "react-redux";
import * as actionFunction from "../../actions/common";

class CustomerList extends Component {
	constructor() {
		super();
		this.state = {
			userid: "",
			uname: "",
			customer_name_muvi6: "",
			errors: {},
			item_name: "",
			item_description: "",
			invoice_amount: "",
			keyacc_selected: "",
			isMuviLive: false,
			isStremInfo: false,
			streamInfo: [],
			showMenu: true,
			isMuviOne: false,
			enterprise_api_gateway_url: "",
			activePage: 1,
			muvisixproductkey: "3D28C83C85544F0D9517DD2E7C7EEDAA",
			search: "",
			store_permission: localStorage.getItem("store_permission"),
			is_general_user: localStorage.getItem("is_general_user"),
			customer_success_permission: localStorage.getItem("customer_success_permission"),
		};
		this.flag = 0;
		this.onChange = this.onChange.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.formdateChange = this.formdateChange.bind(this);
		this.todateChange = this.todateChange.bind(this);
		this.keywordChange = this.keywordChange.bind(this);
		this.keyAcountchange = this.keyAcountchange.bind(this);
	}

	formdateChange(event) {
		this.setState({ from_date: event.target.value }, function () {
			this.getCustomers();
		});
	}

	todateChange(event) {
		this.setState({ to_date: event.target.value }, function () {
			this.getCustomers();
		});
	}

	spaceKeyPress(event) {
		if (event.which == 32 && !event.target.value.length) {
			event.preventDefault();
		}
	}

	setInvoiceDetails(userid, companyname, enterprise_api_gateway_url) {
		this.flag = 0;
		this.setState({
			message: "",
			userid: userid,
			customer_name_muvi6: companyname,
			item_name: "",
			item_description: "",
			invoice_amount: "",
			enterprise_api_gateway_url: enterprise_api_gateway_url,
		});
		document.getElementById("raiseInvoiceModal").style.display = "block";
	}

	submitInvoice() {
		this.flag = 0;
		if (this.handleValidation()) {
		} else {
			return false;
		}
		document.getElementById("submit_invoice").innerHTML = "Sending....";
		document.getElementById("submit_invoice").disabled = true;
		this.props.raiseInvoice(
			this.state.item_name,
			this.state.item_description,
			this.state.invoice_amount,
			this.state.muvisixproductkey,
			this.state.userid,
			this.state.activePage - 1,
			this.state.enterprise_api_gateway_url
		);
		setTimeout(() => {
			this.flag = 1;
		}, 3000);
	}

	isValidNumber(number) {
		var pattern = /^[0-9]*\.?[0-9]*$/;
		return pattern.test(number);
	}

	handleValidation() {
		let errors = {};
		let formIsValid = true;
		if (!this.state.item_name) {
			formIsValid = false;
			errors["item_name"] = "This field is required.";
		}
		if (!this.state.item_description) {
			formIsValid = false;
			errors["item_description"] = "This field is required.";
		}
		if (!this.state.invoice_amount) {
			formIsValid = false;
			errors["invoice_amount"] = "This field is required.";
		}
		if (this.state.invoice_amount && !this.isValidNumber(this.state.invoice_amount)) {
			formIsValid = false;
			errors["invoice_amount"] = "Invalid Amount";
		}
		this.setState({ errors: errors });
		return formIsValid;
	}

	keyAcountchange(event) {
		const post = {
			page: 1,
			keyaccount: event.target.value,
		};
		this.setState({
			activePage: 1,
			customers: [],
			search: "",
			keyacc_selected: event.target.value,
		});
		this.props.getCustomers(post);
	}
	keywordChange(event) {
		var obj = this.props;
		this.setState({
			search: event.target.value,
			activePage: 1,
			customers: [],
		});
		const post = {
			page: 1,
			search: event.target.value,
		};
		//Delaying the function execute
		if (this.timer) {
			window.clearTimeout(this.timer);
		}
		if (obj.muvisixproductkey != "") {
			this.timer = window.setTimeout(() => {
				this.setState({ loading: 1 });
				obj.muvisixCustomerSearchHandler(this.state.muvisixproductkey, this.state.search);
				this.setState({ loading: 0 });
			}, 500);
		} else {
			//Execute the function code here...
			if (this.timer) {
				window.clearTimeout(this.timer);
			}
			this.timer = window.setTimeout(function () {
				obj.getCustomers(post);
			}, 500);
		}
	}

	managerChange(propertyName, event) {
		const id = this.state.id;
		id[propertyName] = event.target.value;
		this.setState({ id: id });
	}

	onChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	cancelupdate(propertyName, event) {
		const cancelupdate = this.state.cancelupdate;
		cancelupdate[propertyName] = event.target.value;
		this.setState({ cancelupdate: cancelupdate });
	}

	handlePageChange(pageNumber = 1) {
		if (this.props.muvisixproductkey != "") {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				const post = {
					muvisixproductkey: this.state.muvisixproductkey,
					pageNumber: pageNumber,
					search: this.state.search,
					offset: this.props.offset,
				};
				this.setState({ activePage: pageNumber, setPage: "no" }, () => {
					this.props.paginationHandel(post);
					$(document).ready(function () {
						$(".pages").removeClass("disabled");
						if (pageNumber == 1) {
							$(".first_page").addClass("disabled");
							$(".prev_page").addClass("disabled");
						}
						if (pageNumber == totalPages) {
							$(".next_page").addClass("disabled");
							$(".last_page").addClass("disabled");
						}
					});
				});
				this.setState({ activePage: pageNumber, setPage: "yes", loading: 0 });
			}
		} else {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				const post = {
					page: pageNumber,
					pagination: 1,
					keyaccount: this.state.keyacc_selected,
				};
				this.setState({ loading: 1, activePage: pageNumber, setPage: "no" }, () => {
					this.props.getCustomers(post);
					$(document).ready(function () {
						$(".pages").removeClass("disabled");
						if (pageNumber == 1) {
							$(".first_page").addClass("disabled");
							$(".prev_page").addClass("disabled");
						}
						if (pageNumber == totalPages) {
							$(".next_page").addClass("disabled");
							$(".last_page").addClass("disabled");
						}
					});
				});
				this.setState({ setPage: "yes", loading: 0 });
			}
		}
	}

	componentDidMount() {
		var page = 1;
		const post = {
			page: page,
		};
		//        this.props.getCustomers(post);
		this.props.getMuvisixCustomerActn("3D28C83C85544F0D9517DD2E7C7EEDAA");
		this.props.getMuviClassicCount();
		document.title = "Intranet | Customers";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}

		this.props.allmuvisixfunc();
		//        if(this.props.muvisixproductkey !==''){
		this.props.getAllAccountManager();
		//    }
	}

	getMuvisixCustomer = (event) => {
		var page = 1;
		const post = {
			page: page,
		};
		const { value } = event.target;
		this.setState({ isMuviLive: false });
		this.setState({ isMuviOne: false });
		if (value !== "") {
			if (value == "8E4F8A19B07D4F22927CD4CB54672D20") {
				this.setState({ isMuviLive: true });
			}
			if (value == "3D28C83C85544F0D9517DD2E7C7EEDAA") {
				this.setState({ isMuviOne: true });
			}

			this.setState({ isStremInfo: false });
			this.setState({ search: "" }, () => {
				this.props.getAllAccountManager();
				this.props.getMuvisixCustomerActn(value);
			});
			this.setState({ activePage: 1, muvisixproductkey: value });
		} else {
			this.setState({ activePage: 1, search: "" }, () => {
				this.props.getCustomers(post);
			});
		}
	};

	// stream info

	getLiveStreamBtn() {
		this.setState({ isStremInfo: true });
		this.setState({ showMenu: false });
		this.getStreamInfo();
	}

	getStreamInfo() {
		var commonStateData = actionFunction.commonData();
		this.setState({ loading: 1 });
		fetch(commonStateData.apiUrl + "/adminRest/getLiveStreamInfo/userAuthKey/" + commonStateData.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: JSON.stringify({
				key: "8E4F8A19B07D4F22927CD4CB54672D20",
				type: "Customer",
			}),
		})
			.then((data) => data.json())
			.then((resp) => {
				this.setState({ streamInfo: resp, loading: 0 });
			});
	}

	stopLiveStream(uuid) {
		var commonStateData = actionFunction.commonData();
		this.setState({ loading: 1 });
		fetch(commonStateData.apiUrl + "/adminRest/stopLiveStream/userAuthKey/" + commonStateData.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: JSON.stringify({
				livestream_uuid: uuid,
			}),
		})
			.then((data) => data.json())
			.then((findresponse) => {
				if (findresponse.code == 200) {
					this.getStreamInfo();
				} else if (findresponse.code == 400) {
					this.getStreamInfo();
				} else {
					this.setState({ loading: 0 });
				}
			});
	}

	getStopStreamBtn(id, product_key, user_uuid, username) {
		return this.state.showMenu ? (
			<ul class="onclick-menu-content">
				<li onClick={() => this.userDataEncrypt(product_key, user_uuid, username)}>
					<a>Log-In to Account</a>
				</li>

				{this.state.store_permission == 1 || this.state.customer_success_permission == 1 ? (
					<li onClick={() => this.stopLiveStream(id)}>
						<a>Stop Stream</a>
					</li>
				) : (
					""
				)}
			</ul>
		) : (
			""
		);
	}

	convertHMS(value) {
		const sec = parseInt(value, 10);
		let hours = Math.floor(sec / 3600);
		let minutes = Math.floor((sec - hours * 3600) / 60);
		let seconds = sec - hours * 3600 - minutes * 60;

		if (hours < 10) {
			hours = "0" + hours;
		}
		if (minutes < 10) {
			minutes = "0" + minutes;
		}
		if (seconds < 10) {
			seconds = "0" + seconds;
		}
		return hours + " Hrs " + minutes + " minutes";
	}

	liveStreamList() {
		return (
			<div class="list_check">
				<div class="tickets hidden-sm">
					<ul class="tickets_head">
						<li class="intra_col_15">Company</li>
						<li class="intra_col_15">Name</li>
						<li class="intra_col_20">Start Time</li>
						<li class="intra_col_20">Duration</li>
						<li class="intra_col_20">Instance ID</li>
						<li class="intra_col_2"></li>
					</ul>
					{this.state.loading == 1 ? (
						<div>
							<div class="loader-new"></div>
						</div>
					) : this.state.streamInfo.code != 400 ? (
						this.state.streamInfo.data.map((item, i) => {
							return (
								<ul class="tickets_number" key={i}>
									<li class="intra_col_15 text-inded">{item.company}</li>
									<li class="intra_col_15 text-inded">{item.name}</li>
									<li class="intra_col_20 text-inded"> {item.start_time} </li>
									<li class="intra_col_20 text-inded"> {this.convertHMS(item.duration)} </li>
									<li class="intra_col_20 text-inded"> {item.instance_id} </li>

									<li
										onClick={this.menuHideShow}
										style={{ position: "relative" }}
										className="intra_col_2"
									>
										<div tabindex="0" class="onclick-menu c-details pull-right">
											<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
											{this.getStopStreamBtn(
												item.livestream_uuid,
												item.product_key,
												item.user_uuid,
												item.username
											)}
										</div>
									</li>
								</ul>
							);
						})
					) : (
						<span>
							<div className="text-center" style={{ color: "#333", marginTop: "15px" }}>
								No Data Found
							</div>
						</span>
					)}
				</div>
			</div>
		);
	}
	// End stream info

	getSourceLink(link) {
		if (link) {
			if (link.indexOf("http") !== -1) {
				var linknew = <a href={`${link}`} target="_blank">{`${link}`}</a>;
				return linknew;
			} else {
				return link;
			}
		} else {
			let na = "NA";
			return na;
		}
	}

	getcustomerpermission(studio_id, studio_name, user_id) {
		if (this.state.store_permission) {
			return (
				<div>
					<li
						onClick={() => this.props.customer_details(studio_id, studio_name, user_id)}
						data-toggle="modal"
						data-target="#changePassword"
					>
						Change Password
					</li>
					<br />
					<li onClick={() => this.props.movetoDemo(studio_id, studio_name, user_id)}>Move to Demo</li>
					<br />
					<li
						onClick={() => this.props.customer_details(studio_id, studio_name, user_id)}
						data-toggle="modal"
						data-target="#cancelAccount"
					>
						Cancel Account
					</li>
				</div>
			);
		}
	}

	CancelAccount(studio_id, user_id, custom_notes, is_charged) {
		this.props.CancelAccountMuvi5(studio_id, user_id, custom_notes, is_charged);
	}

	Savepasswordmuvi5(studio_id, user_id, new_password) {
		this.props.Savepassword(studio_id, user_id, new_password);
	}

	menuHideShow = () => {
		this.setState({
			showMenu: !false,
		});
	};

	userDataEncrypt = (productkey, userid, uname) => {
		this.setState(
			{
				showMenu: false,
				loading: 0,
			},
			() => {
				this.props.userDataEncryptMuvi6(productkey, userid, uname);
			}
		);
	};

	assignAccountManager = (apptoken, company_name, email) => {
		this.setState({
			popup: !false,
			customerAppToken: apptoken,
			studio_name: company_name,
			studio_email: email,
			errors: {},
		});
	};
	//Remove account manager muvi6
	removeAccountManager_muvi6(company_name, apptoken, productkey, email) {
		this.props.removeAccountManager_muvi6(company_name, apptoken, productkey, email);
		//added to redirect same product after action
		this.setState({ isStremInfo: false });
		this.setState({ search: "" }, () => {
			this.props.getAllAccountManager();
			this.props.getMuvisixCustomerActn(productkey);
		});
		this.setState({ activePage: 1, muvisixproductkey: productkey });
		this.setState({ popup: false, accountName: "" });
	}
	//Save acc mngr muvi6
	selectAccountManager = (evt, studio_name, studio_email) => {
		evt.preventDefault();
		let formIsValid = true;
		let errors = {};
		document.getElementById("btn_manager6").disabled = true;
		if (evt.target.accountValue.value == 0 || evt.target.accountValue.value == "") {
			document.getElementById("btn_manager6").disabled = false;
			formIsValid = false;
			errors["manager6"] = "This field is required.";
			this.setState({ errors: errors });
			return formIsValid;
		} else {
			const { options, value } = evt.target;
			let accountName = this.state.accountName;
			const data = {
				managerName: evt.target.accountValue.value,
				customerApptoken: this.state.customerAppToken,
				empName: this.state.accountName,
				productKey: this.state.muvisixproductkey,
				activePage: this.state.activePage,
				studio_name: this.state.studio_name,
				studio_email: this.state.studio_email,
			};
			this.props.assignMuvi6AccountManager(data);
			window.$("#assignaccount").modal("hide");
			document.getElementById("btn_manager6").disabled = false;
			//added to redirect same product after action
			this.setState({ isStremInfo: false });
			this.setState({ search: "" }, () => {
				this.props.getAllAccountManager();
				this.props.getMuvisixCustomerActn(this.state.muvisixproductkey);
			});
			this.setState({
				activePage: 1,
				muvisixproductkey: this.state.muvisixproductkey,
				popup: false,
				accountName: accountName,
				errors: {},
			});
		}
	};
	//change acc mngr muvi5
	SaveAccountManagerMuvi5(studio_id, user_id, studio_name, studio_email) {
		var id = document.getElementById("id").value;
		let formIsValid = true;
		let errors = {};
		document.getElementById("changeAcc").disabled = true;

		if (id == 0) {
			document.getElementById("changeAcc").disabled = false;
			formIsValid = false;
			errors["assign_id"] = "This field is required.";
			this.setState({ errors: errors });
			return formIsValid;
		} else {
			document.getElementById("changeAcc").disabled = false;
			this.props.SaveAccountManager(studio_id, user_id, id, studio_name, studio_email);
			window.$("#changeaccountmanagername").modal("hide");
			this.setState({ errors: {} });
			var page = 1;
			const post = {
				page: page,
			};
			this.setState({ activePage: 1, search: "" }, () => {
				this.props.getCustomers(post);
			});
		}
	}

	//Assign acc mngr muvi5
	AssignAccountManagerMuvi5(studio_id, user_id, studio_name, studio_email) {
		var id = document.getElementById("assign_id").value;
		let formIsValid = true;
		let errors = {};
		document.getElementById("assignAcc").disabled = true;

		if (id == 0) {
			document.getElementById("assignAcc").disabled = false;
			formIsValid = false;
			errors["assign_id"] = "This field is required.";
			this.setState({ errors: errors });
			return formIsValid;
		} else {
			document.getElementById("assignAcc").disabled = false;
			this.props.SaveAccountManager(studio_id, user_id, id, studio_name, studio_email);
			window.$("#assignaccountmanagername").modal("hide");
			this.setState({ errors: {} });
			var page = 1;
			const post = {
				page: page,
			};
			this.setState({ activePage: 1, search: "" }, () => {
				this.props.getCustomers(post);
			});
		}
		this.props.id.id = 0;
	}
	//remove acc mngr muvi5
	RemoveAccountManagerMuvi5(studio_name, studio_id, studio_email) {
		this.props.RemoveAccountManagerMuvi5(studio_name, studio_id, studio_email);
		window.$("#removeaccount5").modal("hide");
		this.setState({ errors: {} });
		var page = 1;
		const post = {
			page: page,
		};
		this.setState({ activePage: 1, search: "" }, () => {
			this.props.getCustomers(post);
		});
	}

	getCustomersMenu(
		account_manager,
		studio_id,
		mname,
		id,
		account_manager_name,
		studio_name,
		user_id,
		email,
		encrypted_password,
		name,
		productkey = null,
		apptoken = null,
		leadToDemo = null,
		useruid = null,
		uname = null,
		company_name = null,
		is_enterprise = false,
		enterprise_api_gateway_url = ""
	) {
		var get_enterprise_api_gateway_url = "";
		if (is_enterprise) {
			var get_enterprise_api_gateway_url = enterprise_api_gateway_url;
		}
		if (this.state.store_permission == 1) {
			return this.state.showMenu ? (
				<ul class="onclick-menu-content">
					{this.props.muvisixproductkey !== "" ? (
						<li onClick={() => this.userDataEncrypt(productkey, useruid, mname)}>
							<a>Log-In to Account</a>
						</li>
					) : (
						<li onClick={() => this.props.goToCustomerStore(email, encrypted_password, studio_id, name)}>
							<a>Log-In to Account</a>
						</li>
					)}
					{this.props.muvisixproductkey !== "" ? (
						<li
							onClick={() => this.assignAccountManager(apptoken, company_name, email)}
							data-toggle="modal"
							data-target="#assignaccount"
						>
							<a>
								{this.filterName(apptoken, productkey) !== "NA"
									? "Change Account Manager"
									: "Assign Account Manager"}
							</a>
						</li>
					) : (
						<li
							onClick={() => {
								this.setState({ show: true });
							}}
						>
							{this.getalertbox(account_manager, studio_id, mname, id, account_manager_name)}{" "}
						</li>
					)}
					{/* ER#75782_9 add new CTA */}
					{this.props.muvisixproductkey !== "" ? (
						this.filterName(apptoken, this.state.muvisixproductkey) !== "NA" ? (
							<li
								onClick={() =>
									this.removeAccountManager_muvi6(company_name, apptoken, productkey, email)
								}
							>
								<a>Remove Account Manager</a>
							</li>
						) : (
							""
						)
					) : account_manager != 0 ? (
						<li
							data-toggle="modal"
							data-target="#removeaccount5"
							onClick={() => this.props.customer_details(studio_id, studio_name, id)}
						>
							<a>Remove Account Manager</a>
						</li>
					) : (
						""
					)}

					{this.props.muvisixproductkey == "" ? (
						<li
							onClick={() => this.props.customer_details(studio_id, studio_name, user_id)}
							data-toggle="modal"
							data-target="#changePassword"
						>
							<a>Change Password</a>
						</li>
					) : (
						""
					)}

					{this.props.muvisixproductkey == "" ? (
						<li
							onClick={() => this.props.customer_details(studio_id, studio_name, user_id)}
							data-toggle="modal"
							data-target="#cancelAccount"
						>
							<a>Cancel Account</a>
						</li>
					) : (
						""
					)}
					{this.props.muvisixproductkey !== "" ? (
						<li
							onClick={() =>
								this.setInvoiceDetails(useruid, company_name, get_enterprise_api_gateway_url)
							}
							data-toggle="modal"
							data-target="#raiseInvoiceModal"
						>
							<a>Raise Custom Invoice</a>
						</li>
					) : (
						""
					)}
				</ul>
			) : (
				""
			);
		} else {
			// ER#75420 is_general_user is used to removed 'Log-in' CTA for general users
			return (
				<ul class="onclick-menu-content">
					{this.state.is_general_user != 1 ? (
						this.props.muvisixproductkey !== "" ? (
							<li onClick={() => this.userDataEncrypt(productkey, useruid, uname)}>
								<a>Log-In to Account</a>
							</li>
						) : (
							<li
								onClick={() => this.props.goToCustomerStore(email, encrypted_password, studio_id, name)}
							>
								<a>Log-In to Account</a>
							</li>
						)
					) : (
						""
					)}

					{this.props.muvisixproductkey !== "" ? (
						<li
							onClick={() =>
								this.setInvoiceDetails(useruid, company_name, get_enterprise_api_gateway_url)
							}
							data-toggle="modal"
							data-target="#raiseInvoiceModal"
						>
							<a>Raise Custom Invoice</a>
						</li>
					) : (
						""
					)}
				</ul>
			);
		}
	}
	getalertbox(account_manager, studio_id, studio_name, id, account_manager_name, email) {
		return (
			<div>
				{account_manager != 0 ? (
					<a
						onClick={() => this.props.customer_details(studio_id, studio_name, id)}
						data-toggle="modal"
						data-target="#changeaccountmanagername"
					>
						Change Account Manager
					</a>
				) : (
					<a
						onClick={() => this.props.customer_details(studio_id, studio_name, id)}
						data-toggle="modal"
						data-target="#assignaccountmanagername"
					>
						Assign Account Manager
					</a>
				)}
			</div>
		);
	}

	loadMorecount() {
		if (this.state.item_count > 0) {
			if (this.state.item_count >= 20) {
				if (this.state.isLoadMore != 2) {
					if (this.state.isLoadMore == 1) {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="load_more" onClick={() => this.loadMore(this.state.activePage)}>
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						);
					} else {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="lds-ripple">
									<div></div>
									<div></div>
								</div>
							</div>
						);
					}
				}
			}
		} else {
			return <div className="text-center blue">No Data Found</div>;
		}
	}
	loadMore(pageNumber) {
		this.setState({ isLoadMore: 0 });
		pageNumber = pageNumber + 1;
		this.setState({ activePage: pageNumber });
		this.props.loadMoreAct(pageNumber);
	}

	setAccountManagerName = (evt) => {
		this.setState({ accountName: evt.target.options[evt.target.selectedIndex].text });
	};
	filterName = (app_token, product_key) => {
		if (this.props.allMuviAccountManager != "") {
			//return app_token
			for (let i = 0; i < this.props.allMuviAccountManager.length; i++) {
				if (
					app_token == this.props.allMuviAccountManager[i].appToken &&
					this.props.allMuviAccountManager[i].productKey == product_key
				) {
					return this.props.allMuviAccountManager[i].empName;
				}
			}
			return "NA";
		}
	};

	muviSixpagination = () => {
		if (20 * (this.state.activePage - 1 + 1) > this.props.item_count) {
			return (
				20 * (this.state.activePage - 1) + 1 + " - " + this.props.item_count + " of " + this.props.item_count
			);
		} else {
			return (
				20 * (this.state.activePage - 1) +
				1 +
				" - " +
				20 * (this.state.activePage - 1 + 1) +
				" of " +
				this.props.item_count
			);
		}
	};

	closeModalAssignAccountManager = () => {
		this.setState({
			popup: false,
			accountName: "",
			errors: {},
			id: 0,
		});
		this.props.id.id = 0;
	};

	loadMorecount() {
		if (this.state.item_count > 0) {
			if (this.state.item_count >= 20) {
				if (this.state.isLoadMore != 2) {
					if (this.state.isLoadMore == 1) {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="load_more" onClick={() => this.loadMore(this.state.activePage)}>
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						);
					} else {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="lds-ripple">
									<div></div>
									<div></div>
								</div>
							</div>
						);
					}
				}
			}
		} else {
			return <div className="text-center blue">No Data Found</div>;
		}
	}

	getCustomerList() {
		let customerKeyaccountFilter = null;
		if (this.props.muvisixproductkey == "") {
			customerKeyaccountFilter = (
				<div class="col-md-6">
					<div class="filter">
						<select
							class="form-control"
							name="keyaccount"
							value={this.state.keyaccount}
							id="keyaccount"
							onChange={this.keyAcountchange}
						>
							<option value="2" selected>
								Customer
							</option>
							<option value="1">Key Account</option>
						</select>
						<i class="fal fa-angle-down"></i>
					</div>
				</div>
			);
		}

		let hideSearchforMuvisix = "";
		hideSearchforMuvisix = (
			<div class="searchTicket mob_customer">
				<input
					type="text"
					value={this.state.search}
					class="form-control"
					name="customer"
					id="customer"
					placeholder="Search company, name or email"
					onChange={this.keywordChange}
				/>
				<button type="submit">
					<i class="fa fa-search"></i>
				</button>
			</div>
		);
		return (
			<section class="customer">
				<div id="exTab1" class="container">
					<CustomerTabMenu brecum_page="customerlist" />
					<div class="tab-content clearfix">
						<div>
							<div class="top-row margin_less m_t_20">
								<div class="row">
									<div class="col-md-5">
										<div class="row">
											<div class="col-md-6">
												{this.state.isStremInfo ? (
													<select
														className="form-control"
														value={this.muvisixproductkey}
														onClick={this.getMuvisixCustomer}
													>
														{this.props.allmuvisix.map((item, index) => {
															return item.product_key !=
																"49F37046FCD84520895FC18A4F5BFC8B" ? (
																item.product_key ==
																"3D28C83C85544F0D9517DD2E7C7EEDAA" ? (
																	<option
																		value={item.product_key}
																		key={index}
																		selected
																	>
																		{item.product_name} ({item.customers})
																	</option>
																) : (
																	<option value={item.product_key} key={index}>
																		{item.product_name} ({item.customers})
																	</option>
																)
															) : (
																<option value="">
																	Muvi One (Classic) ({this.props.muviFiveCount})
																</option>
															);
														})}
													</select>
												) : (
													<select
														className="form-control"
														value={this.muvisixproductkey}
														onChange={this.getMuvisixCustomer}
													>
														{this.props.allmuvisix.map((item, index) => {
															return item.product_key !=
																"49F37046FCD84520895FC18A4F5BFC8B" ? (
																item.product_key ==
																"3D28C83C85544F0D9517DD2E7C7EEDAA" ? (
																	<option
																		value={item.product_key}
																		key={index}
																		selected
																	>
																		{item.product_name} ({item.customers})
																	</option>
																) : (
																	<option value={item.product_key} key={index}>
																		{item.product_name} ({item.customers})
																	</option>
																)
															) : (
																<option value="">
																	Muvi One (Classic) ({this.props.muviFiveCount})
																</option>
															);
														})}
													</select>
												)}
											</div>
											{customerKeyaccountFilter}
											{/* {
                                                this.state.isMuviLive ?
                                                    <div className='col-md-6'>
                                                        <button onClick={() => this.getLiveStreamBtn()} className='btn btn-info'>Stream Info</button>
                                                    </div> : ''
                                            } */}
										</div>
									</div>
									<div class="col-md-1"></div>
									<div class="col-md-6">{hideSearchforMuvisix}</div>
								</div>
							</div>
							{this.state.isStremInfo ? (
								this.liveStreamList()
							) : (
								<div class="list_check">
									<div class="tickets hidden-sm">
										<ul class="tickets_head">
											<li
												class={
													this.props.muvisixproductkey !== ""
														? "intra_col_12"
														: "intra_col_10"
												}
											>
												Company
											</li>
											<li
												class={
													this.props.muvisixproductkey !== ""
														? "intra_col_10"
														: "intra_col_10"
												}
											>
												Email
											</li>
											{this.props.muvisixproductkey === "" || this.state.isMuviOne ? (
												<li class="intra_col_12">Website</li>
											) : (
												""
											)}
											<li
												class={
													this.props.muvisixproductkey != "" ? "intra_col_12" : "intra_col_9"
												}
											>
												Country
											</li>
											<li
												class={
													this.props.muvisixproductkey != "" ? "intra_col_13" : "intra_col_12"
												}
											>
												Package Name
											</li>
											{this.props.muvisixproductkey === "" ? (
												<li class="intra_col_12">Apps</li>
											) : (
												""
											)}
											<li
												class={
													this.props.muvisixproductkey != "" ? "intra_col_10" : "intra_col_11"
												}
											>
												Joined On
											</li>
											<li
												class={
													this.props.muvisixproductkey != "" ? "intra_col_10" : "intra_col_9"
												}
											>
												Source
											</li>
											{this.props.muvisixproductkey == "" ? (
												<li class="intra_col_13">Account Manager</li>
											) : (
												""
											)}
											{this.props.muvisixproductkey != "" ? (
												<li class="intra_col_13">Account Manager</li>
											) : (
												""
											)}
										</ul>
										{this.props.loading ? (
											<div>
												<div class="loader-new"></div>
											</div>
										) : (
											this.props.customers.map((data, key) => (
												<ul class="tickets_number">
													<li class="intra_col_10 text-inded">
														{this.props.muvisixproductkey == "" ? (
															<Link
																key={key}
																to={`/test/detail/${data.studio_id}`}
																name={"max"}
															>
																{" "}
																{data.company_name
																	? data.company_name
																	: data.name
																	? data.name
																	: "NA"}
															</Link>
														) : (
															<Link
																key={key}
																to={`/test/detail/${data.app_token}`}
																name={"max"}
															>
																{" "}
																{data.company_name
																	? data.company_name
																	: data.name
																	? data.name
																	: "NA"}
															</Link>
														)}
													</li>
													<li
														class={
															this.props.muvisixproductkey != ""
																? "intra_col_12"
																: "intra_col_10"
														}
													>
														{data.email ? data.email : "NA"}
													</li>
													{this.props.muvisixproductkey == "" || this.state.isMuviOne ? (
														<li class="intra_col_12 text-inded">
															<a
																href={`http://${
																	data.domain ? data.domain : data.domain_name
																}`}
																target="_blank"
																title={data.domain}
															>
																{data.domain ? data.domain : data.domain_name}
															</a>
														</li>
													) : (
														""
													)}
													<li
														class={
															this.props.muvisixproductkey != ""
																? "intra_col_12 text-inded"
																: "intra_col_9 text-inded"
														}
													>
														{data.country
															? data.country
															: data.country_name
															? data.country_name
															: "NA"}
													</li>
													<li
														class={
															this.props.muvisixproductkey != ""
																? "intra_col_13"
																: "intra_col_12"
														}
													>
														{data.highvalue == 1
															? [data.plan_name, <br />, "Key Account"]
															: data.plan_name
															? data.plan_name
															: data.package_name
															? data.package_name
															: "NA"}
													</li>
													{this.props.muvisixproductkey == "" ? (
														<li
															class={
																this.props.muvisixproductkey != ""
																	? "intra_col_12"
																	: "intra_col_12"
															}
															title={data.application_sale}
														>
															{data.application_sale ? data.application_sale : "NA"}
														</li>
													) : (
														""
													)}
													<li
														class={
															this.props.muvisixproductkey != ""
																? "intra_col_10"
																: "intra_col_11"
														}
													>
														{data.created_at_change
															? new Date(data.created_at_change).toLocaleDateString(
																	"en-US",
																	{ month: "short", day: "numeric", year: "numeric" }
															  )
															: new Date(data.created_date).toLocaleDateString("en-US", {
																	month: "short",
																	day: "numeric",
																	year: "numeric",
															  })}
													</li>
													<li
														class={
															this.props.muvisixproductkey != ""
																? "intra_col_10 text-inded"
																: "intra_col_9 text-inded"
														}
													>
														{data.source ? this.getSourceLink(data.source) : "NA"}
													</li>
													{this.props.muvisixproductkey != "" ? (
														<li className="intra_col_13">
															{this.filterName(
																data.app_token,
																this.state.muvisixproductkey
															)
																? this.filterName(
																		data.app_token,
																		this.state.muvisixproductkey
																  )
																: "NA"}{" "}
														</li>
													) : (
														<li className="intra_col_13">
															{data.account_manager_name !== "None"
																? data.account_manager_name
																: "NA"}
														</li>
													)}
													<li
														onClick={this.menuHideShow}
														style={{ position: "relative" }}
														className="intra_col_2"
													>
														{/* ER#75420: 3 dots are hidden */}
														{this.state.is_general_user == 1 &&
														this.props.muvisixproductkey == "" ? (
															<div></div>
														) : (
															<div tabindex="0" class="onclick-menu c-details pull-right">
																<i class="fa fa-ellipsis-v" aria-hidden="true"></i>

																{this.getCustomersMenu(
																	data.account_manager,
																	data.studio_id,
																	data.name,
																	data.id,
																	data.account_manager_name,
																	data.first_name,
																	data.user_id,
																	data.email,
																	data.encrypted_password,
																	data.name,
																	this.state.muvisixproductkey,
																	data.app_token,
																	false,
																	data.user_uuid,
																	data.username,
																	data.company_name,
																	data.is_enterprise,
																	data.enterprise_api_gateway_url
																)}
															</div>
														)}
													</li>
												</ul>
											))
										)}
									</div>
									<div class="customer_mob hidden-md">
										{this.props.customers.map((data, key) => (
											<div class="custmer_list_mob">
												<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
													<h4 class="list_title">{data.first_name}</h4>
												</Link>
												<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
													<div class="wrap">{data.domain}</div>
												</Link>
												<div tabindex="0" class="onclick-menu pull-right">
													<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
													{this.getCustomersMenu(
														data.studio_id,
														data.first_name,
														data.user_id,
														data.email,
														data.encrypted_password,
														data.name
													)}
												</div>
											</div>
										))}
									</div>
									{this.props.loading ? (
										""
									) : (
										<span>
											{this.props.item_count > 0 ? (
												<div class="pagination-muvi">
													<Pagination
														itemClass={"pages"}
														itemClassFirst={"first_page"}
														itemClassPrev={"prev_page"}
														itemClassNext={"next_page"}
														itemClassLast={"last_page"}
														activePage={this.state.activePage}
														itemsCountPerPage={20}
														totalItemsCount={this.props.item_count}
														pageRangeDisplayed={5}
														onChange={
															this.props.setPage == "yes" ? this.handlePageChange : ""
														}
													/>
													<div style={{ color: "#333" }}>
														{this.props.muvisixproductkey == ""
															? this.props.offset +
															  1 +
															  " - " +
															  (this.props.offset + this.props.off_count) +
															  " of " +
															  this.props.item_count
															: this.muviSixpagination()}
													</div>
												</div>
											) : (
												<div className="text-center" style={{ color: "#333" }}>
													No Data Found
												</div>
											)}
										</span>
									)}
								</div>
							)}
						</div>
						<div class="clearfix"></div>
					</div>
				</div>
			</section>
		);
	}
	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}
		return (
			<div>
				{this.state.popup ? (
					<div
						className={`modal fade ${this.state.popup ? "show" : ""}`}
						id="assignaccount"
						role="dialog"
						style={this.state.popup ? { opacity: "1", marginTop: "10px" } : ""}
					>
						<div class="modal-dialog modal-md">
							<div class="modal-content" style={this.state.popup ? { marginTop: "65px" } : ""}>
								<div class="modal-header">
									{/* <button type="button" class="close" data-dismiss="modal" onClick={() => this.setState({ popup: !true })}>&times;</button> */}
									<h4 style={{ color: "black" }} class="modal-title">
										Set Account Manager
									</h4>
								</div>
								<div class="modal-body">
									<form
										onSubmit={(evt) =>
											this.selectAccountManager(
												evt,
												this.state.studio_name,
												this.state.studio_email
											)
										}
									>
										<div className="form-group">
											<label>
												<b>Account Manager</b>
												<span class="star">*</span>
											</label>
											<select
												name="accountValue"
												id="manager6"
												className="form-control"
												onChange={(evt) => this.setAccountManagerName(evt)}
											>
												<option value="">-Select-</option>
												{this.props.allEmployee.map((data) => {
													return <option value={data.id}>{data.name}</option>;
												})}
											</select>
											<span class="error">{this.state.errors["manager6"]}</span>
										</div>
										<div className="modal-footer">
											<button
												type="button"
												class="btn btn-blue"
												data-dismiss="modal"
												onClick={() => this.setState({ popup: !true })}
											>
												Cancel
											</button>
											<button type="submit" id="btn_manager6" className="btn btn-sky">
												Submit
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				) : (
					""
				)}
				<div class="modal fade" id="cancelAccount" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Cancel Account
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>Company</b>
								</label>
								<input
									type="text"
									name="company"
									value={this.props.studio_id_name}
									className="form-control"
									onChange={this.onChange}
									readOnly
								/>
								<input
									type="hidden"
									value={this.props.studio_id_id}
									name="studio_id"
									onChange={this.onChange}
								/>
								<input
									type="hidden"
									value={this.props.user_id_id}
									name="user_id"
									onChange={this.onChange}
								/>
								<br />
								<label>
									<b>Reason</b>
								</label>
								<textarea
									style={{ resize: "none" }}
									class="form-control"
									name="custom_notes"
									id="custom_notes"
									required
									onChange={this.onChange}
								></textarea>
								<span style={{ color: "red" }}> {this.props.message1}</span>
								<br />
								<label>
									<b>Do you want to charge this customer?</b>
								</label>
								<div class="radio feature-check">
									<input
										class="valid_fld"
										id="3"
										type="radio"
										name="is_charged"
										value="1"
										onChange={this.onChange}
									/>
									<label for="3">
										<span></span>
										Yes
									</label>
								</div>
								<div class="radio feature-check">
									<input
										class="valid_fld"
										id="4"
										type="radio"
										name="is_charged"
										value="0"
										onChange={this.onChange}
									/>
									<label for="4">
										<span></span>
										No
									</label>
								</div>
								<span style={{ color: "red" }}>{this.props.message1}</span>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-sky"
									onClick={() =>
										this.CancelAccount(
											this.props.studio_id_id,
											this.props.user_id_id,
											this.state.custom_notes,
											this.state.is_charged
										)
									}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--raise invoice for muvi 6-!> */}
				<div class="modal fade" id="raiseInvoiceModal" role="dialog" data-backdrop="static">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Raise Invoice
								</h4>
							</div>
							<div class="modal-body">
								<div class="form-group">
									<label class="span2 control-label" for="company" style={{ fontSize: "20px" }}>
										{this.state.customer_name_muvi6}
									</label>
								</div>
								Title
								<input
									type="text"
									class="form-control"
									name="item_name"
									value={this.state.item_name}
									onKeyPress={this.spaceKeyPress}
									onChange={this.onChange}
									placeholder=""
								/>
								<span class="error">{this.state.errors["item_name"]}</span>
								<br></br>
								Description
								<input
									type="text"
									class="form-control"
									name="item_description"
									value={this.state.item_description}
									onKeyPress={this.spaceKeyPress}
									onChange={this.onChange}
									placeholder=""
								/>
								<span class="error">{this.state.errors["item_description"]}</span>
								<br></br>
								Amount($)
								<input
									type="text"
									class="form-control"
									name="invoice_amount"
									value={this.state.invoice_amount}
									onKeyPress={this.spaceKeyPress}
									onChange={this.onChange}
									placeholder=""
								/>
								<span class="error">{this.state.errors["invoice_amount"]}</span>
								<br></br>
							</div>
							<span style={{ color: "red" }}>
								{this.props.message && this.flag == 1 ? this.props.message : ""}
							</span>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									name="submit_invoice"
									id="submit_invoice"
									class="btn btn-sky"
									onClick={() => this.submitInvoice()}
								>
									Submit Invoice
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for cancelling account-!> */}
				{/* <--modal end for restrict change Account Manager Name If Exists-!> */}
				<div class="modal fade" id="restrictchangeaccountmanagername" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title text-center">
									Set Account Manager
								</h4>
							</div>
							<div class="modal-body text-center">
								<br />
								Oops!... You are not authorized to change/assign account manager to store.
								<br />
								<br />
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for restrict change Account Manager-!> */}
				{/* <--modal start for change Password-!> */}
				<div class="modal fade" id="changePassword" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Update Password
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>New Password</b>
								</label>
								<input
									type="text"
									name="new_password"
									id="new_password"
									className="form-control"
									onChange={this.onChange}
								/>
								<span style={{ color: "red" }}>{this.props.message}</span>
								<input type="hidden" value={this.props.studio_id_id} name="studio_id" />
								<input type="hidden" value={this.props.user_id_id} name="user_id" />
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-sky"
									onClick={() =>
										this.Savepasswordmuvi5(
											this.props.studio_id_id,
											this.props.user_id_id,
											this.state.new_password
										)
									}
								>
									Update
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for change Password-!> */}
				{/* <--modal end for change Account Manager Name If Exists-!> */}
				<div class="modal fade" id="removeaccount5" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-body">
								<div style={{ marginBottom: "10px" }}>
									Are you sure you want to remove an Account Manager? Removing an account manager will
									Unmark this customer as Key Account.
								</div>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-sky"
									id="removeAccount"
									onClick={() =>
										this.RemoveAccountManagerMuvi5(
											this.props.studio_id_name,
											this.props.studio_id_id,
											this.props.studio_email
										)
									}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for change Account Manager Name If Exists-!> */}
				<div class="modal fade" id="changeaccountmanagername" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								{/* <button type="button" class="close" data-dismiss="modal">&times;</button> */}
								<h4 style={{ color: "black" }} class="modal-title">
									Set Account Manager
								</h4>
							</div>
							<div class="modal-body">
								<div style={{ marginBottom: "10px" }}>
									<label>
										<b>Account Manager</b>
										<span class="star">*</span>
									</label>
									<select
										class="form-control"
										id="id"
										name="id"
										required={1}
										value={this.props.id.id}
										onChange={
											this.props.id.id ? this.managerChange.bind(this, "id") : this.onChange
										}
									>
										<option value="0">-Select-</option>
										{this.props.account_manager.map((account_manager, key) => (
											<option value={account_manager.id}>{account_manager.name}</option>
										))}
									</select>
									<span class="error">{this.state.errors["id"]}</span>
								</div>
								<input type="hidden" value={this.props.studio_id_id} name="studio_id" />
								<input type="hidden" value={this.props.user_id_id} name="user_id" />
								<input type="hidden" value={this.props.studio_email} name="studio_email" />
							</div>
							<div class="modal-footer">
								<button
									type="button"
									class="btn btn-blue"
									data-dismiss="modal"
									onClick={this.closeModalAssignAccountManager}
								>
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-sky"
									id="changeAcc"
									onClick={() =>
										this.SaveAccountManagerMuvi5(
											this.props.studio_id_id,
											this.props.user_id_id,
											this.props.studio_id_name,
											this.props.studio_email
										)
									}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="modal fade" id="assignaccountmanagername" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								{/* <button type="button" class="close" data-dismiss="modal">&times;</button> */}
								<h4 style={{ color: "black" }} class="modal-title">
									Set Account Manager
								</h4>
							</div>
							<div class="modal-body">
								<div>
									Note: Assigning an account manager will mark this customer as Key Account, to Unmark
									it please open customer details page and Unmark it.
								</div>
								<div style={{ marginTop: "10px", marginBottom: "10px" }}>
									<label>
										<b>Account Manager</b>
										<span class="star">*</span>
									</label>
									<select
										class="form-control"
										id="assign_id"
										name="id"
										value={this.props.id.id}
										onChange={
											this.props.id.id ? this.managerChange.bind(this, "id") : this.onChange
										}
										required={1}
									>
										<option value="0">-Select-</option>
										{this.props.account_manager.map((account_manager, key) => (
											<option value={account_manager.id}>{account_manager.name}</option>
										))}
									</select>
									<span class="error">{this.state.errors["assign_id"]}</span>
								</div>
								<input type="hidden" value={this.props.studio_id_id} name="studio_id" />
								<input type="hidden" value={this.props.user_id_id} name="user_id" />
								<input type="hidden" value={this.props.studio_email} name="studio_email" />
							</div>
							<div class="modal-footer">
								<button
									type="reset"
									class="btn btn-blue"
									data-dismiss="modal"
									onClick={this.closeModalAssignAccountManager}
								>
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-sky"
									id="assignAcc"
									onClick={() =>
										this.AssignAccountManagerMuvi5(
											this.props.studio_id_id,
											this.props.user_id_id,
											this.props.studio_id_name,
											this.props.studio_email
										)
									}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				<Header brecum_name="Customer" brecum_page="Customers" />
				<div className="right_col">{this.getCustomerList()}</div>
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		customers: state.cLRe.customers,
		item_count: state.cLRe.item_count,
		//        muviFiveCount: state.cLRe.item_count,
		//        store_permission: state.cLRe.store_permission,
		//        customer_success_permission: state.cLRe.customer_success_permission,
		//        is_general_user: state.cLRe.is_general_user,
		package: state.cLRe.package,
		loading: state.cLRe.loading,
		offset: state.cLRe.offset,
		off_count: state.cLRe.off_count,
		setPage: "yes",
		muvisixproductkey: state.cLRe.muvisixproductkey,
		studio_id: state.cLRe.studio_id,
		user_id: state.cLRe.user_id,
		id: state.cLRe.id,
		account_manager: state.cLRe.account_manager,
		allEmployee: state.cLRe.allEmployee,
		allMuviAccountManager: state.cLRe.allMuviAccountManager,
		allmuvisix: state.cLRe.allmuvisix,
		muviFiveCount: state.cLRe.muviFiveCount,
		isLoadMore: state.cLRe.isLoadMore,
		user_data: state.cLRe.user_data,
		message: state.cLRe.message,
		message1: state.cLRe.message1,
		show: state.cLRe.show,
		studio_id_id: state.cLRe.studio_id_id,
		studio_email: state.cLRe.studio_email,
		user_id_id: state.cLRe.user_id_id,
		studio_id_name: state.cLRe.studio_id_name,
		code: state.cLRe.code,
	};
};
const mapDispatchToProps = {
	getCustomers,
	customer_details,
	getAllAccountManager,
	allmuvisixfunc,
	getMuvisixCustomerActn,
	muvisixCustomerSearchHandler,
	loadMoreAct,
	paginationHandel,
	goToCustomerStore,
	userDataEncryptMuvi6,
	assignMuvi6AccountManager,
	SaveAccountManager,
	removeAccountManager_muvi6,
	RemoveAccountManagerMuvi5,
	Savepassword,
	CancelAccountMuvi5,
	raiseInvoice,
	fetchProductByKey,
	getMuviClassicCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);



// WEBPACK FOOTER //
// ./src/components/customer/CustomerList.js